/* eslint-disable no-plusplus */
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import { ReadOnlyEditor } from '../DolEditor/DolEditorReadOnly';
import { BlogEditorProps } from './BlogEditor.types';
import { useBlogEditorReadOnlyPlugin } from './hooks/useBlogEditorReadOnlyPlugin';

/**
 * Experimental new renderer (removing slate) for readonly mode
 */
export const BlogEditorReadOnly = observer(
  React.forwardRef((props: BlogEditorProps, ref) => {
    const {
      initialValue,
      onBackWhenInComplete,
      preprocessReadOnlyInitialValues,
      plugins: overridePlugins,
      ...rest
    } = props;
    const { plugins, preprocessReadOnlyInitialValues: defaultPreprocessInitialValue } =
      useBlogEditorReadOnlyPlugin({
        onBackWhenInComplete,
      });

    const preprocessedInitialValue = React.useMemo(() => {
      if (preprocessReadOnlyInitialValues) {
        return preprocessReadOnlyInitialValues({ initialValue });
      }
      return defaultPreprocessInitialValue({ initialValue });
    }, [preprocessReadOnlyInitialValues, defaultPreprocessInitialValue, initialValue]);

    return (
      <ReadOnlyEditor
        initialValue={preprocessedInitialValue}
        plugins={overridePlugins || plugins}
        {...rest}
      />
    );
  })
);
